import "./stats.css";
import {
  Divider,
  Datepicker,
  Dropdown,
  Button,
} from "@fluentui/react-northstar";
import React, { useEffect, useState } from "react";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { Icon } from "@fluentui/react/lib/Icon";
import AttendedByQueue from "./charts/attendedByQueue";
import DistributionByQueue from "./charts/distributionByQueue";
import DistributionByTime from "./charts/distributionByTime";
import CallsByAgent from "./tables/callsByAgent";
import AttendedByAgent from "./charts/attendedByAgent";
import OutboundByAgent from "./charts/outboundByAgent";
import StatsService from "../apiservices/StatsService";
import TagsService from "../apiservices/TagsService";
import TimingsByQueue from "./charts/timingsByQueue";
import TimingsByTime from "./charts/timingsByTime";
import OutboundByAgentTimers from "./charts/outboundByAgentTimers";
import BarOutbound from "./charts/outbound/outboundByAgent";

initializeIcons();

const Stats = () => {
  const [showStats, setShowStats] = useState(false);
  const [showOutbound, setshowOutbound] = useState(false);
  const [initDate, setInitDate] = useState(new Date());
  const [finDate, setFinDate] = useState(new Date());
  const [queueSelected, setQueueSelected] = useState([]);
  const [agentSelected, setAgentSelected] = useState([]);
  const [distributionByQueueData, setDistributionByQueueData] = useState();
  const [data, setData] = useState([]);
  const [inputItems, setInputItems] = useState([]);
  const [inputAgents, setInputAgents] = useState([]);

  const [isQueueAttButtonPressed, setisQueueAttButtonPressed] = useState(true);
  const [isQueueTimingsButtonPressed, setisQueueTimingsButtonPressed] =
    useState(true);
  const [isOutboundByAgentButtonPressed, setisOutboundByAgentButtonPressed] =
    useState(true);

  const [tags, setTags] = useState([]);

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDate(date) {
    return [
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
      date.getFullYear(),
    ].join("-");
  }

  const showStatsToTrue = async () => {
    setShowStats(false);

    setTimeout(function () {
      setShowStats(true);
    }, 1000);
  };

  const showOutboundToTrue = async () => {
    setshowOutbound(false);

    setTimeout(function () {
      setshowOutbound(true);
    }, 1000);
  };
  const getA11ySelectionMessage = {
    onAdd: (item) => setQueueSelected([...queueSelected, item]),
    onRemove: (item) => `${item} has been removed.`,
    itemsCount: (count) => {
      let narration;

      if (count === 1) {
        narration = `${count} item is selected.`;
      } else if (count >= 2) {
        narration = `${count} items are selected.`;
      }

      return narration;
    },
  };

  const getA11ySelectionAgents = {
    onAdd: (item) => setAgentSelected([...agentSelected, item]),
    onRemove: (item) => `${item} has been removed.`,
    itemsCount: (count) => {
      let narration;

      if (count === 1) {
        narration = `${count} item is selected.`;
      } else if (count >= 2) {
        narration = `${count} items are selected.`;
      }

      return narration;
    },
  };

  function getToken() {
    const tokenString = sessionStorage.getItem("tokenStats");
    console.log(tokenString);
    return tokenString;
  }

  function getTags() {
    const username = sessionStorage.getItem("userName");
    TagsService.getGroups(username)
      .then((response) => {
        setTags(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  useEffect(() => {
    const token = getToken();
    const username = sessionStorage.getItem("userName");
    const company = sessionStorage.getItem("company");
    StatsService.getActualQueues(token, username, company).then((res) =>
      setInputItems(res.data)
    );
    getTags();
  }, []);

  return (
    <div className="statsPage">
      <h1>Stats</h1>
      <div className="divider">
        <Divider />
      </div>
      <h2 className="filtros"> Filters </h2>
      <div className="filterData">
        <div className="filteringDates">
          <h4>
            <Icon iconName="CalendarSettings" /> Date range
          </h4>
          <div className="datePicker1">
            <Datepicker
              inputPlaceholder="Initial date"
              today={new Date()}
              defaultSelectedDate={new Date()}
              onDateChange={(e, v) => {
                setInitDate(v.value);
              }}
            />
          </div>
          <div className="datePicker2">
            <Datepicker
              inputPlaceholder="Final Date"
              today={new Date()}
              defaultSelectedDate={new Date()}
              onDateChange={(e, v) => {
                setFinDate(v.value);
              }}
            />
          </div>
        </div>
        <div className="filteringQueues">
          <h4>
            <Icon iconName="Group" /> Grupos
          </h4>
          <div className="selectQueues">
            <Dropdown
              search
              multiple
              items={inputItems}
              placeholder="Start typing any group name.. "
              getA11ySelectionMessage={getA11ySelectionMessage}
              noResultsMessage="No hemos encontrado ningún grupo con ese nombre"
              a11ySelectedItemsMessage="Press Delete or Backspace to remove"
            />
          </div>
        </div>
        <div className="filteringAgents">
          <h4>
            <Icon iconName="ReminderPerson" /> Tags
          </h4>
          <div className="selectAgents">
            <Dropdown
              disabled
              search
              multiple
              items={tags}
              placeholder="Start typing any tag name.. "
              getA11ySelectionMessage={getA11ySelectionAgents}
              noResultsMessage="We couldn't find any matches."
              a11ySelectedItemsMessage="Press Delete or Backspace to remove"
            />
          </div>
        </div>
      </div>
      <div>
        <br></br>
        <Button onClick={showStatsToTrue} primary content="Aplicar filtros" />
      </div>
      <br></br>
      <Divider />
      <br></br>

      {showStats ? (
        <>
          <Button
            onClick={() => setshowOutbound(false)}
            primary
            content="Inbound"
          />
          {"  "}
          <Button
            onClick={showOutboundToTrue}
            primary
            disabled
            content="Outbound"
          />
          {showOutbound ? (
            <BarOutbound />
          ) : (
            <div>
              <div>
                <h2>Distribution by Queue</h2>
                <div className="distribucionPorCola">
                  <div className="grafico1">
                    <div style={{ marginBottom: "10px" }}>
                      <Button
                        content="Attention"
                        size="small"
                        tinted
                        onClick={() => setisQueueAttButtonPressed(true)}
                      />
                      <Button
                        content="Timings"
                        size="small"
                        tinted
                        onClick={() => setisQueueAttButtonPressed(false)}
                      />
                    </div>
                    {isQueueAttButtonPressed ? (
                      <DistributionByQueue
                        queue={queueSelected}
                        initDate={formatDate(initDate)}
                        endDate={formatDate(finDate)}
                      />
                    ) : (
                      <TimingsByQueue
                        queue={queueSelected}
                        initDate={formatDate(initDate)}
                        endDate={formatDate(finDate)}
                      />
                    )}
                  </div>
                  <div className="grafico2">
                    <div style={{ marginBottom: "10px" }}></div>
                    <AttendedByQueue
                      queue={queueSelected}
                      initDate={formatDate(initDate)}
                      endDate={formatDate(finDate)}
                    />
                  </div>
                  <div className="grafico3">
                    <div style={{ marginBottom: "10px" }}>
                      <Button
                        content="Attention"
                        size="small"
                        tinted
                        onClick={() => setisQueueTimingsButtonPressed(true)}
                      />
                      <Button
                        content="Timings"
                        size="small"
                        tinted
                        onClick={() => setisQueueTimingsButtonPressed(false)}
                      />
                    </div>
                    {isQueueTimingsButtonPressed ? (
                      <DistributionByTime
                        queue={queueSelected}
                        initDate={formatDate(initDate)}
                        endDate={formatDate(finDate)}
                      />
                    ) : (
                      <TimingsByTime
                        queue={queueSelected}
                        initDate={formatDate(initDate)}
                        endDate={formatDate(finDate)}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "70px" }}>
                <h2>Distribution by Agent</h2>
                <div className="distribucionPorCola">
                  <div className="grafico4">
                    <div
                      style={{ marginTop: "10px", overflow: "scroll" }}
                    ></div>
                    <CallsByAgent
                      queue={queueSelected}
                      initDate={formatDate(initDate)}
                      endDate={formatDate(finDate)}
                    />
                  </div>
                  <div className="grafico2">
                    <div style={{ marginTop: "10px" }}></div>
                    <AttendedByAgent
                      queue={queueSelected}
                      initDate={formatDate(initDate)}
                      endDate={formatDate(finDate)}
                    />
                  </div>
                  <div className="grafico3">
                    <div style={{ marginBottom: "10px" }}>
                      <Button
                        content="Attention"
                        size="small"
                        tinted
                        onClick={() => setisOutboundByAgentButtonPressed(true)}
                      />
                      <Button
                        content="Timings"
                        size="small"
                        tinted
                        onClick={() => setisOutboundByAgentButtonPressed(false)}
                      />
                    </div>
                    {isOutboundByAgentButtonPressed ? (
                      <OutboundByAgent
                        queue={queueSelected}
                        initDate={formatDate(initDate)}
                        endDate={formatDate(finDate)}
                      />
                    ) : (
                      <OutboundByAgentTimers
                        queue={queueSelected}
                        initDate={formatDate(initDate)}
                        endDate={formatDate(finDate)}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default Stats;
